<template>
    <div class="stores">
        <div class="stores-map">
            <!--高德地图容器-->
            <div ref="mapContainer" class="amap-view"></div>
        </div>
        <div class="stores-list">
            <div>
                <p>查询线下门店</p>
                <div class="stores-area">
                    <el-select v-model="provinceObj" placeholder="请选择省" @change="provinceChange" value-key="name" style="width:45%;margin-right: 1rem;">
                        <el-option v-for="(item, index) in provinceData" :key="index" :label="item.name" :value="item"></el-option>
                    </el-select>
                    <el-select v-model="cityObj" placeholder="请选择市" @change="cityChange" value-key="name" style="width:45%;">
                        <el-option v-for="(item, index) in cityData" :key="index" :label="item.name" :value="item"></el-option>
                    </el-select>
                </div>
                <p class="nearStores" @click="nearbyStores">
                    <img src="../assets/nearby-stores.png" alt="">
                    查找附近门店
                </p>
            </div>
            <div>
                <p class="store-list-box">门店列表</p>
                <div class="stores-box" v-show="storesData.length != 0">
                    <div class="store-list" v-for="(item,index) in storesData" :key="index" @click="lookDetail(item, 'right')">
                        <p class="store-title">布瑞琳{{item.name}}</p>
                        <p class="store-address">{{item.address}}</p>
                        <p class="store-phone">电话： {{item.phone2}}</p>
                    </div>
                </div>
                <div class="stores-box" style="display: flex;justify-content: center;align-items: center;" v-show="storesData.length == 0">
                    <div>敬请期待</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import gcoord from 'gcoord'

// 高德地图凭证（Web端 JS API）
// 申请/管理地址：https://console.amap.com/dev/key/app
// 应用类型必须选「Web端(JS API)」
// 说明：当前使用 JS API 1.4 版本，只需要 Key，不需要安全密钥(securityJsCode)。
//       安全密钥是 2.0 版本（2021-12 之后）才强制的；若日后升级到 2.0 需同时填安全密钥。
const AMAP_KEY = '74e60a21fe179ecf14fb4c1d719ee544';
const AMAP_SECURITY_CODE = ''; // 1.4 版本无需安全密钥，留空即可

export default {
    name: "pm-distribution",
    data(){
        return{
            // 地图中心（GCJ02 坐标，高德使用 GCJ02）
            map:{ center:{ lng: 116.4, lat: 39.9 }, zoom: 12 },
            mapInstance: null,
            markerLayer: [],        // AMap.Marker 数组
            infoWindowInstance: null,
            markers: [],

            provinceObj: {name: ''},
            cityObj: {name: ''},
            provinceData: [],
            cityData: [],
            storesData:[],
            infoWindow: {
                show: false,
                info: {},
            },
        }
    },
    watch:{
        markers(){
            this.renderMarkers();
        }
    },
    created(){
        this.$fetch("store/fetch",{}).then(res => {
            this.storesData = res;
            this.markers = res;
        })
        this.$fetch("store/select/province").then(res => {
            console.log('store/select/province',res);
            this.provinceData = res.data;
        })
    },
    mounted(){
        this.loadAMapScript().then(() => {
            this.initMap();
            this.renderMarkers();
        }).catch(err => {
            console.error('高德地图脚本加载失败', err);
        });
    },
    beforeDestroy(){
        this.clearMarkers();
        if(this.infoWindowInstance){
            this.infoWindowInstance.close && this.infoWindowInstance.close();
            this.infoWindowInstance = null;
        }
        if(this.mapInstance){
            this.mapInstance.destroy && this.mapInstance.destroy();
            this.mapInstance = null;
        }
    },

    methods:{
        // 动态加载高德 JS API 1.4（1.4 只需 Key，不强制安全密钥）
        loadAMapScript(){
            return new Promise((resolve, reject) => {
                if(window.AMap){
                    resolve();
                    return;
                }
                // 若配置了安全密钥（升级到 2.0 时）才注入，且必须先于脚本加载
                if(AMAP_SECURITY_CODE){
                    window._AMapSecurityConfig = {
                        securityJsCode: AMAP_SECURITY_CODE,
                    };
                }
                const callbackName = '__onAMapLoaded__';
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = `https://webapi.amap.com/maps?v=1.4.15&key=${AMAP_KEY}&callback=${callbackName}`;
                window[callbackName] = () => {
                    resolve();
                };
                script.onerror = () => {
                    reject(new Error('高德地图脚本加载失败，请检查网络或 Key 配置'));
                };
                document.head.appendChild(script);
            });
        },

        // 初始化地图
        initMap(){
            const AMap = window.AMap;
            this.mapInstance = new AMap.Map(this.$refs.mapContainer, {
                zoom: this.map.zoom,
                center: [this.map.center.lng, this.map.center.lat],
                resizeEnable: true,
            });

            // 信息窗先创建（核心功能），避免控件初始化失败导致 infoWindowInstance 为 null
            this.infoWindowInstance = new AMap.InfoWindow({
                offset: new AMap.Pixel(0, -40),
                isCustom: false,
            });

            // 比例尺 + 工具条（1.4 中属插件，可能不可用，失败不影响地图主体）
            try{
                this.mapInstance.addControl(new AMap.Scale());
                this.mapInstance.addControl(new AMap.ToolBar());
            }catch(e){
                console.warn('高德控件加载失败，跳过', e);
            }
        },

        // 安全解析坐标：null / undefined / 空字符串 / 非数字 一律返回 NaN，交给 isFinite 过滤
        parseCoord(v){
            if(v === null || v === undefined || v === '') return NaN;
            return Number(v);
        },

        // 后端存的是 BD09（百度坐标），高德使用 GCJ02，需要转换
        toGcj02(lng, lat){
            const [gcjLng, gcjLat] = gcoord.transform(
                [Number(lng), Number(lat)],
                gcoord.BD09,
                gcoord.GCJ02
            );
            return { lng: gcjLng, lat: gcjLat };
        },

        // 构建蓝色渐变水滴标记的 HTML（CSS 绘制，比图片更清晰、可控）
        buildMarkerContent(){
            return `
                <div class="store-marker">
                    <div class="store-marker-body"></div>
                </div>
            `;
        },

        // 渲染 marker（自定义蓝色标记）
        renderMarkers(){
            if(!this.mapInstance || !window.AMap) return;
            const AMap = window.AMap;
            this.clearMarkers();

            (this.markers || []).forEach((item, idx) => {
                const lo = this.parseCoord(item.lo);
                const la = this.parseCoord(item.la);
                // 过滤坐标非法的门店，避免报错
                if(!Number.isFinite(lo) || !Number.isFinite(la)) return;

                const { lng, lat } = this.toGcj02(lo, la);
                const marker = new AMap.Marker({
                    position: [lng, lat],
                    content: this.buildMarkerContent(),
                    offset: new AMap.Pixel(-14, -34), // 锚点在标记尖端（底部中心）
                    title: item.name || '',
                    map: this.mapInstance,
                });
                marker.on('click', () => {
                    this.lookDetail(item);
                });
                this.markerLayer.push(marker);
            });
        },

        clearMarkers(){
            this.markerLayer.forEach(m => m.setMap && m.setMap(null));
            this.markerLayer = [];
        },

        provinceChange(value){
            this.cityData = value.children  // 市下拉列表
            this.cityObj = {} // 清空市输入框内容
        },
        cityChange(value){
            console.log(value);
            this.$fetch("store/select/city", {id: value.id}).then(res => {
                console.log('store/select/city',res);
                this.storesData = res;
            })
        },

        // 查找附近门店：使用高德定位插件（返回 GCJ02），再转 BD09 调后端旧接口
        nearbyStores(){
            if(!window.AMap || !this.mapInstance) return;
            const AMap = window.AMap;
            AMap.plugin('AMap.Geolocation', () => {
                const geo = new AMap.Geolocation({
                    enableHighAccuracy: true,
                    timeout: 8000,
                });
                geo.getCurrentPosition((status, result) => {
                    if(status !== 'complete' || !result || !result.position){
                        console.error('定位失败', result);
                        this.$message && this.$message.warning('定位失败，请检查浏览器定位权限');
                        return;
                    }
                    const [gcjLng, gcjLat] = result.position; // GCJ02

                    // GCJ02 → BD09（后端旧接口用）
                    const [bdLng, bdLat] = gcoord.transform(
                        [gcjLng, gcjLat],
                        gcoord.GCJ02,
                        gcoord.BD09
                    );

                    this.mapInstance.setCenter([gcjLng, gcjLat]);
                    this.mapInstance.setZoom(12);

                    this.$fetch("store/nearby/stores", { lo: bdLng, la: bdLat, dis: 6 }).then(res => {
                        console.log('store/nearby/stores', res);
                        this.storesData = res.data;
                        this.markers = res.data;
                    })
                });
            });
        },

        lookDetail(data, target){
            console.log(data, target);
            if(!this.mapInstance || !window.AMap) return;
            const AMap = window.AMap;

            // 信息窗若未初始化（地图未就绪/控件异常）则按需补建，避免 null.setContent 报错
            if(!this.infoWindowInstance){
                this.infoWindowInstance = new AMap.InfoWindow({
                    offset: new AMap.Pixel(0, -40),
                    isCustom: false,
                });
            }

            const rawLo = this.parseCoord(data.lo);
            const rawLa = this.parseCoord(data.la);
            if(!Number.isFinite(rawLo) || !Number.isFinite(rawLa)){
                console.warn('门店坐标非法，跳过定位', data);
                return;
            }
            const { lng, lat } = this.toGcj02(rawLo, rawLa);

            this.infoWindow.show = true;
            this.infoWindow.info = data;

            const content = `
                <div class="amap-info-window">
                    <div class="amap-info-title">布瑞琳${data.name || ''}</div>
                    <p><span class="left">地址：</span><span class="right">${data.address || ''}</span></p>
                    <p><span class="left">电话：</span><span class="right">${data.phone2 || ''}</span></p>
                </div>
            `;
            this.infoWindowInstance.setContent(content);
            this.infoWindowInstance.open(this.mapInstance, [lng, lat]);

            if(target === 'right'){ // 点击的是左侧列表项，把地图移动到该位置
                this.mapInstance.setCenter([lng, lat]);
                this.mapInstance.setZoom(15);
                this.map.center = { lng, lat };
                this.map.zoom = 15;
            }
        },
    },
}
</script>

<style scoped lang="scss">
.stores{
    margin: 2rem 0;
}


.stores-map{
    display: inline-block;
    width: 70%;
    .amap-view {
        width: 100%;
        height: 45rem;
    }
}
.stores-list{
    display: inline-block;
    width: 30%;
    height: 45rem;
    background: #fff;
    float: right;
    text-align: left;
    padding: 1.5rem 3rem 0.5rem 3rem;
    overflow: hidden;

    .stores-area{
        margin: 1rem 0;
    }

    .nearStores{
        font-size: 0.5rem;
        color: #666;
        cursor: pointer;

        img{
            width: 0.8rem;
            vertical-align: middle;
            margin-right: 0.8rem;
        }
    }

    .store-list-box{
        margin: 2rem 0 1rem;
        font-size: 1.5rem;
    }

    .stores-box{
        height: 31.6rem;
        overflow: auto;
    }
    .store-list{
        border-top: 1px solid #DEDEDE;
        padding: 1rem 0;
        cursor: pointer;

        .store-title{
            color: #00146E;
        }
        .store-address{
            margin: 0.2rem 0 0.5rem;
            font-size: 0.6rem;
            color: #666;
        }
        .store-phone{
            font-size: 0.9rem;
        }
    }
}
</style>

<!-- 高德 InfoWindow 内容渲染到地图容器外，scoped 样式无法覆盖，需要非 scoped 样式 -->
<style lang="scss">
.amap-info-window{
    max-width: 260px;
    padding: 4px 6px;
    .amap-info-title{
        color: #00146E;
        font-size: 16px;
        font-weight: bolder;
        margin-bottom: 6px;
    }
    p{
        margin: 2px 0;
        font-size: 13px;
        line-height: 1.5;
        .left{ color: #666; }
    }
}

/* 自定义蓝色渐变水滴标记（marker content 注入到地图 DOM，需非 scoped） */
.store-marker{
    position: relative;
    width: 28px;
    height: 34px;
    cursor: pointer;

    /* 地面阴影 */
    &::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 14px;
        height: 5px;
        background: rgba(0, 20, 110, 0.25);
        border-radius: 50%;
        filter: blur(1px);
    }

    .store-marker-body{
        position: absolute;
        top: 0;
        left: 0;
        width: 28px;
        height: 28px;
        background: linear-gradient(135deg, #4D9FFF 0%, #1667E0 100%);
        border-radius: 50% 50% 50% 0;
        transform: rotate(-45deg);
        box-shadow: 0 3px 10px rgba(22, 103, 224, 0.45);
        transition: transform 0.2s ease;

        /* 中心白点 */
        &::after{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 10px;
            height: 10px;
            background: #fff;
            border-radius: 50%;
        }
    }

    &:hover .store-marker-body{
        transform: rotate(-45deg) scale(1.15);
    }
}
</style>
